var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.isClient)?_c('v-btn',{staticClass:"navigation-announce",attrs:{"icon":"","small":""},on:{"click":_setup.handleClick}},[_c(_setup.Icon,{staticClass:"site-header__icon",attrs:{"name":"bell-circle","size":"lg","color":"gray-0"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }